import { getField, updateField } from "vuex-map-fields";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    error: "",
    isLoading: false,
    items: [],
    selectItems: null,
    view: [],
    // START:CUSTOM - generated
    totalItems: 0,
    itemsPerPage: 50,
    pageNo: 1,
    search: "",
    orderBy: "",
    orderDir: "",
    filters: { by: String, val: String }, //could be array but I think map is better
    // END:CUSTOM - generated
  },
  actions,
  getters: {
    getField,
  },
  mutations: {
    updateField,
    ...mutations,
  },
};
